import "core-js/stable";
import "regenerator-runtime/runtime";

require("@rails/ujs").start()

import 'stylesheets/hartlepoolatn/application.scss'

import 'javascripts/video_conferencing'
